import { render } from "./OtherDiscoverItem.vue?vue&type=template&id=0cf6dffb&scoped=true"
import script from "./OtherDiscoverItem.vue?vue&type=script&lang=js"
export * from "./OtherDiscoverItem.vue?vue&type=script&lang=js"

import "./OtherDiscoverItem.vue?vue&type=style&index=0&id=0cf6dffb&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf6dffb"]])

export default __exports__